import axios from '@/axios.js'

const state = () => ({
    taxonomies: [],
    barangs: [],
})

const mutations = {
    SET_TAXONOMIES (state, payload) {
      state.taxonomies = payload
    },
    SET_NULL_BARANGS (state) {
      state.barangs = []
    },
    SET_BARANGS (state, payload) {
      state.barangs = payload
    },
    ADD_TAXONOMY (state, item) {
      state.taxonomies.unshift(item)
    },
    REMOVE_TAXONOMY (state, itemId) {
      const ItemIndex = state.taxonomies.findIndex((p) => p.id === itemId)
      state.taxonomies.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchTaxonomy ({ commit }, taxonomy) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-sort/${taxonomy}/ASC`)
        .then((response) => {
          commit('SET_TAXONOMIES', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addTaxonomy ({ commit }, taxonomy ) {
    return new Promise((resolve, reject) => {
      axios.post('/taxonomy-add', taxonomy)
        .then((response) => {
          commit('ADD_TAXONOMY', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeTaxonomy ({ commit }, taxonomy) {
    return new Promise((resolve, reject) => {
      axios.delete(`/taxonomy-delete/${taxonomy.taxonomy_id}`)
        .then((response) => {
            commit('REMOVE_TAXONOMY', taxonomy.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBarang ({ commit }, taxonomy) {
    return new Promise((resolve, reject) => {
        axios.get(`/term-list-sort/${taxonomy}/ASC`)
        .then((response) => {
          commit('SET_BARANGS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}